import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { BsImages } from "react-icons/bs";
import axios from "axios";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_ITEMKITS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { uploadAWS } from "../../../../common/AWSHelper";
import { toastError, toastSuccess } from "../../../../common/Toast";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import { useParams } from "react-router-dom";

const Images = (props) => {
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({ Image: "" });
  const [changeImagename, setChangeImagename] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [selectedImage, setSelectedImage] = useState("");

  const ActionButtons = (props) => {
    const handleBack = () => {
      props.previousStep();
      window.scrollTo(0, 0);
    };

    const handleNext = () => {
      props.nextStep();
      window.scrollTo(0, 0);
      if (ImageUrl) {
        handleSubmit();
      }
    };

    return (
      <div className="text-center mb-3">
        {props.currentStep > 1 && (
          <button onClick={handleBack} className="btn btn-primary me-3">
            Back
          </button>
        )}
        {props.currentStep < props.totalSteps && (
          <button onClick={handleNext} className="btn btn-primary">
            Next
          </button>
        )}
      </div>
    );
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type, index) => {
    setBtnLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_ITEMKITS, (data) => {
      if (data) {
        if (type === "SelectImage") {
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const _handleImageChange = (event, index) => {
    setChangeImagename(true);

    if (validation(event.target.name, event?.currentTarget?.files[0])) {
      uploadFile(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
          setPreviewImage(images);
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };
  const handleNext = () => {
    props.nextStep();
    window.scrollTo(0, 0);
    if (ImageUrl) {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    setLoading(true);

    axios
      .post(
        `${config.itemKitsBaseUrl}/itemkits/imagesupsert`,
        {
          imagenames: ImageUrl,
          itemkitid: paramObject.id,
          loginuserid: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (paramObject.id > 0) {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/imagesfindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setSelectedImage(res.data.ResponseData.Itemkitsimages[0].Name);
          setImageUrl(res.data.ResponseData.Itemkitsimages[0].Name);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title">
            <BsImages className="me-1" />
            Upload Images
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-primary btn-md me-1"
              >
                Back
              </button>
            )}
            {props.currentStep < props.totalSteps && (
              <button
                onClick={handleNext}
                className="btn btn-primary btn-md"
                type="submit"
              >
                Next
              </button>
            )}
          </div>
        </div>

        <div className="card-body">
          <Formik {...props} initialValues={formValues} enableReinitialize>
            <Form>
              <div className="row">
                <div className="col-md-2 mb-3 align-center">
                  <label className="form-label">Select Image/Images</label>
                </div>
                <div className="col-md-5 mb-3">
                  <input
                    type="file"
                    className="form-control"
                    id="SelectImage"
                    name="SelectImage"
                    multiple
                    onChange={_handleImageChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-2 mb-3 align-center">Image Preview</div>
                <div
                  className={`${
                    ImageUrl ? "" : selectedImage ? "" : "d-none"
                  } form-group row`}
                >
                  <label className="col-form-label col-md-2 form-label"></label>
                  <div className="col-md-10">
                    <img
                      src={`${ImageUrl ? ImageUrl : selectedImage}`}
                      alt="Item_Image"
                      className="ItemImage w-25 h-100"
                    />
                  </div>
                </div>
              </div>
            </Form>
          </Formik>
        </div>

        <ActionButtons {...props} />
      </div>
    </>
  );
};

export default Images;
